module.exports = __webpack_public_path__ + "img/Frente-16-00 off.ce1aa261.png";